import { render, staticRenderFns } from "./LegalBanner.vue?vue&type=template&id=35d99c74&scoped=true"
var script = {}
import style0 from "./LegalBanner.scss?vue&type=style&index=0&id=35d99c74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d99c74",
  null
  
)

export default component.exports